export default "__VITE_ASSET__CKdfHp4T__"